/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/


import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Form } from 'formik';
import { Button, CircularProgress, Select, FormControl, FormControlLabel, Grid, InputLabel, Switch, FormHelperText, MenuItem } from '@mui/material';
import { useEffect } from 'react';
import { getAllGetchkdUsers } from '../../../../../../../store/reducers/getchkdUser/getchkdUserAction';
import { getAllRole } from '../../../../../../../store/reducers/role/roleAction';
import { getAllOrg } from '../../../../../../../store/reducers/organization/organizationAction';

const OrgUserForm = ({ errors, touched, values, handleBlur, handleChange, setFieldValue, handleClose, isSubmitting }) => {
    const dispatch = useDispatch()
    const getchkdUsers = useSelector(state => state.getchkdUser.getchkdUsers)
    const roles = useSelector(state => state.role.roles);
    const organizations = useSelector(state => state.organization.organizations)
    useEffect(() => {
        dispatch(getAllGetchkdUsers());
        dispatch(getAllRole())
        dispatch(getAllOrg())
    }, [dispatch]);

    return (


        <Form>

            <Grid container spacing={4}>
                <Grid item xs={12} md={12} sm={12}>


                    {values.hasOwnProperty("organizationID") && <FormControl fullWidth error={Boolean(touched.organizationID && errors.organizationID)}>
                        <InputLabel htmlFor="outlined-status">Organization</InputLabel>
                        <Select
                            value={values.organizationID}
                            variant="outlined"
                            name="organizationID"
                            label="Owner"
                            onBlur={handleBlur}
                            onChange={handleChange}
                            style={{ color: 'white' }}
                        >
                            {organizations?.Records?.length > 0 && organizations?.Records?.map((item) => (
                                <MenuItem value={item.organizationID}>
                                    {item.organizationName}
                                </MenuItem>
                            ))}


                        </Select>
                        <FormHelperText style={{ color: "red" }} >{errors.organizationID}</FormHelperText>

                    </FormControl>}

                </Grid>
                <Grid item xs={12} md={12} sm={12}>


                    {values.hasOwnProperty("getChkdID") && <FormControl fullWidth error={Boolean(touched.getChkdID && errors.getChkdID)}>
                        <InputLabel htmlFor="outlined-status">User</InputLabel>
                        <Select
                            value={values.getChkdID}
                            variant="outlined"
                            name="getChkdID"
                            label="Owner"
                            onBlur={handleBlur}
                            onChange={handleChange}
                            style={{ color: 'white' }}
                        >
                            {getchkdUsers?.Records?.length > 0 && getchkdUsers?.Records?.map((item) => (
                                <MenuItem value={item.getChkdID}>
                                    {item.email}
                                </MenuItem>
                            ))}


                        </Select>
                        <FormHelperText style={{ color: "red" }} >{errors.getChkdID}</FormHelperText>

                    </FormControl>}

                </Grid>

                <Grid item xs={12} md={12} sm={12}>

                    {values.hasOwnProperty("roleID") && <FormControl fullWidth error={Boolean(touched.roleID && errors.roleID)}>
                        <InputLabel htmlFor="outlined-status">Role</InputLabel>
                        <Select
                            value={values.roleID}
                            variant="outlined"
                            name="roleID"
                            label="Role"
                            onBlur={handleBlur}
                            onChange={handleChange}
                            style={{ color: 'white' }}
                        >
                            {roles?.length > 0 && roles?.map((item) => (
                                <MenuItem value={item.roleID}>
                                    {item.roleName}
                                </MenuItem>
                            ))}


                        </Select>
                        <FormHelperText style={{ color: "red" }} >{errors.roleID}</FormHelperText>

                    </FormControl>
                    }
                </Grid>
                {values.detailValue && <Grid item xs={12} md={6} sm={6}>
                    <FormControlLabel
                        control={<Switch />}
                        name="organizationUserDetails"
                        checked={values.detailValue === "true"}
                        onChange={(event, checked) => {
                            setFieldValue("detailValue", checked ? "true" : "false");
                        }}
                        label={values.detailValue === "true" ? 'Authorized' : 'Unauthorized'}
                    />
                </Grid>}
                <Grid item xs={12} md={12} sm={12}>
                    <Button
                        variant="contained"
                        color="primary"
                        type="submit" style={{ marginTop: '20px' }}
                        disabled={isSubmitting}>
                        {isSubmitting &&
                            <CircularProgress size={24} color='success' style={{ marginLeft: '10px' }} />} Save
                    </Button>
                    <Button variant="outlined" onClick={() => handleClose()} style={{ marginTop: '20px', marginLeft: '10px' }}>close</Button>

                </Grid>

            </Grid>
        </Form>

    )

}


export default OrgUserForm;
